var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('shippingOperations'),"description":_vm.$t('FromHereYouCanControlShipments')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('searchForOperation'),"emptyTableText":_vm.$t('NoShipments'),"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"buttonRole":_vm.$checkRole('shippingOperations_add'),"statusSearch":true,"statusValues":[
          { title: _vm.$t('Situation'), value: '' },
          { title: _vm.$t('All'), value: '' },
          { title: _vm.$t('Draft'), value: 0 },
          { title: _vm.$t('Sent'), value: 1 },
          { title: _vm.$t('Seen'), value: 2 },
          { title: _vm.$t('Driven'), value: 3 },
          { title: _vm.$t('Canceled'), value: 4 }
        ],"cloumns":[
          {
            column: 'code',
            title: _vm.$t('operationCode'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'client_type',
            title: _vm.$t('Customer name'),
            type: 'clintLink',
            sort: false
          },
          {
            column: 'date',
            title: _vm.$t('Date'),
            type: 'text',
            sort: true
          },
          {
            column: 'invoice_id',
            title: _vm.$t('Invoice code'),
            type: 'linkInvoice',
            to: 'invoice',
            sort: true,
            link: true
          },
          {
            column: 'tracking_number',
            title: _vm.$t('trackingNumber'),
            type: 'text',
            sort: true
          },
          {
            column: 'status',
            title: _vm.$t('theStatus'),
            type: 'status',
            sort: true,
            values: [
              {
                title: _vm.$t('Draft'),
                value: 0,
                color: 'dark'
              },
              {
                title: _vm.$t('Sent'),
                value: 1,
                color: 'primary'
              },
              {
                title: _vm.$t('Seen'),
                value: 2,
                color: 'primary'
              },
              {
                title: _vm.$t('Driven'),
                value: 3,
                color: 'success'
              },
              {
                title: _vm.$t('Canceled'),
                value: 4,
                color: 'danger'
              }
            ]
          },
          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: _vm.$checkRole('shippingOperations_edit')
              },
              { name: 'printInvoice', role: true },
              {
                name: 'delete',
                role: _vm.$checkRole('shippingOperations_delete')
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }